import { LambdaAdmin } from "../../common/services/http-service"

const useSearch = () => {

    const getLastTickets = async (usuarioId, status, inicio, final) => {
        try {           
            return await LambdaAdmin({ resource: `soporte/tickets?UsuarioID=${usuarioId}&Status=${status}&Inicial=${inicio}&Final=${final}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getTicketsByUser = async (ticketID) => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket/empleado/${ticketID}`, method: "GET", });    
        } catch (error) {
            console.log('[Error on getTicketsByUser]:', error)
            return null
        }
    };

    const getEmployeeByCURP = async (curp) => {
        try {
            return await LambdaAdmin({ resource: `soporte/usuarios?CURP=${curp}`, method: "GET", });
        } catch (error) {
            return { data: [] }
        }
    };

    const getEmployeeByForm = async (nombre, ape, fechaNacimiento, estado) => {
        try {
            return await LambdaAdmin({ resource: `soporte/usuarios/formulario?Nombre=${nombre}&Ape=${ape}&FechaNacimiento=${fechaNacimiento}&Estado=${estado}`, method: "GET", });
        } catch (error) {
            return { data: [] }
        }
    };

    const getHistorialSoporte = async(ticketID, fechinicio, fechFin, device) => {
        // Metodo getKardexByEmployee
        try {
            // return await Lambda({ resource: `soporte/kardex?TicketID=${ticketID}&Inicial=${fechinicio}&Final=${fechFin}&Device=${device}`, method: "GET", });
            return await LambdaAdmin({ resource: `soporte/kardex?TicketID=${ticketID}&Inicial=${fechinicio}&Final=${fechFin}&Device=${device}`, method: "GET", });
        } catch (error) {
            return null
        }
    }

    const getTicketLogsPorEmpleado = async (ticketID, fechinicio, fechFin, usuarioId) => {
        try {
            return await LambdaAdmin({ resource: `soporte/tickets/empleado?TicketID=${ticketID}&Inicial=${fechinicio}&Final=${fechFin}&UsuarioID=${usuarioId}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getTicketSesiones = async (ticketID, fechinicio, fechFin, Device) => {
        try {
            return await LambdaAdmin({ resource: `soporte/tickets/sesion?TicketID=${ticketID}&Inicial=${fechinicio}&Final=${fechFin}&Device=${Device}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getModulos = async (empresaID, empNumero, activo) => {
        try {
            return await LambdaAdmin({ resource: `soporte/modulos?EmpresaID=${empresaID}&EmpNumero=${empNumero}&Activo=${activo}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getCompaniesByCurp = async (curp) => {
        try {
            return await LambdaAdmin({ resource: `soporte/usuario/empresas?CURP=${curp}`, method: "GET", });
        } catch (error) {
            return null
        }
    };

    const getPayrolls = async (curp, inicial, final, status) => {
        try {
            return await LambdaAdmin({ resource: `soporte/usuario/nominas?CURP=${curp}&Inicial=${inicial}&Final=${final}&Status=${status}`, method: "GET", });
        } catch (error) {
            return null;
        }
    };

    return {
        getLastTickets,
        getTicketsByUser,
        getEmployeeByCURP,
        getEmployeeByForm,
        getTicketSesiones,
        getHistorialSoporte,
        getTicketLogsPorEmpleado,
        getModulos,
        getPayrolls,
        getCompaniesByCurp
    };
};

export default useSearch;